import UnlinkedTransferAccountsPage from "components/pages/UnlinkedTransferAccountsPage";
import { useModel } from "bcms-react";
/**
 * @name CaptureTransferAccounts
 * @returns {React.Component}
 * @description Capture component for the "Unlinked Accounts" page.
 */
export default function CaptureTransferAccounts(props) {
     // Branding options needed for captures
  const branding = useModel().branding.options;
  window.BRANDING = { "transfer_accounts_abi22" : branding.transfer_accounts_abi22 };
    return <UnlinkedTransferAccountsPage />
}